import { useCallback, useState } from "react";
import { DdqProdOpsWizardStep } from "~/graphql/supergraphEnums";

export type UseWizardStateResult = {
  currentStep: DdqProdOpsWizardStep;
  goToStep: (step: DdqProdOpsWizardStep) => void;
};

// null = not yet advanced, so currentStep tracks derivedStep instead of freezing on first render.
export const useWizardState = (derivedStep: DdqProdOpsWizardStep): UseWizardStateResult => {
  const [manualStep, setManualStep] = useState<DdqProdOpsWizardStep | null>(null);

  const goToStep = useCallback((step: DdqProdOpsWizardStep) => {
    setManualStep(step);
  }, []);

  return { currentStep: manualStep ?? derivedStep, goToStep };
};
